(function() {
    'use strict';

    /**
     * Used by ngStyles to style the element on a scroll event.
     */
    function scrollStyle(currentPosition) {
        var transform = {
            'transform': 'translateX(-' + currentPosition + 'px)',
            '-ms-transform': 'translateX(-' + currentPosition + 'px)'
        };

        return transform;
    }

    /**
     * @controller - This is the definition of the scroll area controller, which contains and sets up the variables
     *               used in the scrollable area.
     *
     * @param $scope - The current angular scope.
     * @method scroll - Enacts a scroll.
     * @method scrollStyle - Defines action to be taken on successful scroll.
     */
    function scrollArea($scope) {
        var prevPosition = 0;

        $scope.currentPosition = 0;

        $scope.scroll = function(left) {
            var scrollAmount = $scope.scrollAmount;
            prevPosition = $scope.currentPosition;

            if (left) {
                scrollAmount = scrollAmount * -1;
            }

            var newPosition = $scope.currentPosition + scrollAmount;

            $scope.currentPosition = newPosition < 0 ? 0 :
                (newPosition > $scope.maxWidth ? $scope.maxWidth : newPosition);

            var positionSame = $scope.currentPosition === prevPosition;

            if (positionSame && $scope.currentPosition === 0) {
                $scope.currentPosition = $scope.maxWidth;
            } else if (positionSame && $scope.currentPosition === $scope.maxWidth) {
                $scope.currentPosition = 0;
            }
        };

        $scope.scrollStyle = scrollStyle;
    }

    /**
     * @controller - This is the controller wrapper for the scroll area controller.
     *
     * @param $scope - current angular scope.
     * @returns - An Object which contains the $scope for this controller.
     */
    function scrollAreaController($scope, $element) {
        scrollArea($scope);

        return {
            $scope: $scope,
            $element: $element
        };
    }

    /**
     * @link - This is the link function for the scrollerise directive.
     *
     * @param $scope - Current angular scope.
     * @param $element - Current angular element.
     * @param $attrs - Angular element attributes.
     * @param ScrollCtrl - Scroll area controller object.
     */
    function scrolleriseLink($scope, $element, $attrs, ScrollCtrl) {
        var $elem = $element[0];

        if ($elem.style.flex !== undefined) {
            var _maxWidth = function() {
                var maxWidth = $elem.scrollWidth - $elem.clientWidth;

                if (maxWidth <= 0) {
                    ScrollCtrl.$scope.scrollerise = true;
                } else {
                    ScrollCtrl.$scope.scrollerise = false;
                    ScrollCtrl.$scope.maxWidth = maxWidth;
                }
            };

            ScrollCtrl.$scope.maxWidth = _maxWidth;

            vhols.eventDebounce(function() {
                _maxWidth();
            }, 'resize', window, 300);

            _maxWidth();
        } else {
            ScrollCtrl.$element.addClass('no-flex');
        }
    }

    /**
     * Scroll area angular configuration.
     */
    angular.module('vhols')

        .controller('ScrollAreaController', function($scope) { })

        .constant('SCROLL_AREA_CONSTANTS', {
            scrollAreaTemplate : 'template/directives/scroll-area.html'
        })

        .directive('retrieveHotels', ['$window', 'hotelsService', '$timeout', function ($window, hotelsService, $timeout) {
            return {
                link: function ($scope, $element) {
                    $scope.hotels = [];

                    hotelsService.getHotels().then(function (result) {
                        $scope.hotels = result;
                        $scope.$root.$broadcast('hotelCount', $scope.hotels.length);
                        $scope.hotels.forEach(function (holiday) {
                            var urlSlug = holiday.hotel.content.url.substring(holiday.hotel.content.url.lastIndexOf('/') + 1, holiday.hotel.content.url.length)
                            if ($window.location.pathname.indexOf('travel-extras/airport-hotels/') > 0) {
                                holiday.hotel.content.finalLink = '/destinations' + holiday.hotel.content.url + '-browse';
                            } else {
                                holiday.hotel.content.finalLink = $window.ngVariables.HOLIDAY_TYPES ? $window.location.pathname.replace(/overview/, 'hotels/' + holiday.hotel.content.urlName)
                                    : '/destinations' + holiday.hotel.content.url + '-browse';
                            }

                            holiday.hotel.content.urlSlug = urlSlug;
                        });
                        $scope.currentURL = location.protocol + '//' + location.hostname;

                        $timeout(function() {
                            var event;
                            if (typeof (Event) === 'function') {
                                event = new Event('initialise-card-carousel');

                            } else {
                                event = document.createEvent('Event');
                                event.initEvent('initialise-card-carousel', true, true);
                            }
                            window.dispatchEvent(event);
                            window.postMessage('INITIALISE_HOTLIST_BUTTONS', '*');
                        });
                    }, function (error) {
                        console.error('No hotels found');
                    });
                }
            };
        }])

        .directive('scrollArea', ['SCROLL_AREA_CONSTANTS', function(SCROLL_AREA_CONSTANTS) {
            return {
                controller: scrollAreaController,
                link: function($scope, $element, $attrs) {
                    $scope.scrollAmount = parseInt($attrs.scrollAmount, 10);
                },
                transclude: true,
                templateUrl: SCROLL_AREA_CONSTANTS.scrollAreaTemplate
            };
        }])

        .directive('scrollSection', function() {
            return {
                require: '^scrollArea',
                restrict: 'C',
                link: scrolleriseLink
            };
        });
})();
